import Logo from "../assets/svg/logo.svg";
import Icon_Social1 from "../assets/svg/icon1.svg";
import Icon_Social2 from "../assets/svg/icon2.svg";
import Icon_Social3 from "../assets/svg/icon3.svg";
import Icon_Social4 from "../assets/svg/icon4.svg";
import Logo1 from "../assets/logos/logo1.svg";
import Logo2 from "../assets/logos/logo2.svg";
import Logo3 from "../assets/logos/logo3.svg";
import Logo4 from "../assets/logos/logo4.svg";
import Logo5 from "../assets/logos/logo5.svg";
import Logo6 from "../assets/logos/logo6.svg";
import Logo7 from "../assets/logos/logo7.svg";
import Logo8 from "../assets/logos/logo8.svg";
import Logo9 from "../assets/logos/logo9.svg";
import short_logo from "../assets/logos/short_logo.svg";
import C_Logo1 from "../assets/logos/clogo1.svg";
import C_Logo2 from "../assets/logos/clogo2.svg";
import C_Logo3 from "../assets/logos/clogo3.svg";
import C_Logo4 from "../assets/logos/clogo4.svg";
import C_Logo5 from "../assets/logos/clogo5.svg";
import C_Logo6 from "../assets/logos/clogo6.svg";
import C_Logo7 from "../assets/logos/clogo7.svg";
import C_Logo8 from "../assets/logos/clogo8.svg";
import linkedin from "../assets/svg/linkedin.svg";
import twitter from "../assets/svg/twitter.svg";
import Buyer_Img from "../assets/buyer.svg";
import Clientsvg1_Img from "../assets/clientsvg1.svg";
import Clientsvg2_Img from "../assets/clientsvg2.svg";
import Reach_Img from "../assets/reach.svg";
import LogoIcon_IMG1 from "../assets/integrations/logoicon1.svg";
import LogoIcon_IMG2 from "../assets/integrations/logoicon2.svg";
import LogoIcon_IMG3 from "../assets/integrations/logoicon3.svg";
import LogoIcon_IMG4 from "../assets/integrations/logoicon4.svg";
import LogoIcon_IMG5 from "../assets/integrations/logoicon5.svg";
import LogoIcon_IMG6 from "../assets/integrations/logoicon6.svg";
import LogoIcon_IMG7 from "../assets/integrations/logoicon7.svg";
import LogoIcon_IMG8 from "../assets/integrations/logoicon8.svg";
import LogoIcon_IMG9 from "../assets/integrations/logoicon9.svg";
import LogoIcon_IMG10 from "../assets/integrations/logoicon10.svg";
import LogoIcon_IMG11 from "../assets/integrations/logoicon11.svg";
import LogoIcon_IMG12 from "../assets/integrations/logoicon12.svg";
import LogoIcon_IMG13 from "../assets/integrations/logoicon13.svg";
import LogoIcon_IMG14 from "../assets/integrations/logoicon14.svg";
import Circle_IMG1 from "../assets/svg/circle1.svg";
import Circle_IMG2 from "../assets/svg/circle2.svg";
import Circle_IMG3 from "../assets/svg/circle3.svg";
import Play_Circle from "../assets/svg/play-circle.svg";
import Search_Normal from "../assets/svg/search-normal.svg";
import Verified from "../assets/svg/verified.svg";
import Help_Img from "../assets/help.svg";
import about_img from "../assets/about.svg";
import Value1_Img from "../assets/svg/value1.svg";
import Value2_Img from "../assets/svg/value2.svg";
import Value3_Img from "../assets/svg/value3.svg";
import Aboutsvg_Img from "../assets/aboutsvg.svg";
import Checkuser_Img from "../assets/checkuser.svg";
import RightArrow_Img from "../assets/svg/rightarrow.svg";
import CheckCircle_Img from "../assets/svg/checkcircle.svg";
import VIcon1_Img from "../assets/steps/icon1.svg";
import VIcon2_Img from "../assets/steps/icon2.svg";
import VIcon3_Img from "../assets/steps/icon3.svg";
import VIcon4_Img from "../assets/steps/icon4.svg";
import Earthquake_Img from "../assets/earthquake.svg";
import Thanks_Img from "../assets/thanks.svg";
import RArrow_Img from "../assets/svg/rarrow.svg";
import Edit_Img from "../assets/svg/edit.svg";

// Images
import Banner_Img from "../assets/bannerbg.jpg";
import Gradient_Img from "../assets/gradient.jpg";
import Gradient1_Img from "../assets/gradient1.png";
import Review_Img from "../assets/review.jpg";
import BuyerTransparent_Img from "../assets/buyertransparent.png";
import User1_Img from "../assets/users/user1.png";
import User2_Img from "../assets/users/user2.png";
import User3_Img from "../assets/users/user3.png";
import Breadcrumb_Img from "../assets/breadcrumb.jpg";
import Product_Img from "../assets/product.jpg";
import Product_Img1 from "../assets/product1.jpg";
import Media_Img1 from "../assets/media/media1.jpg";
import Media_Img2 from "../assets/media/media2.jpg";
import Media_Img3 from "../assets/media/media3.jpg";
import Media_Img4 from "../assets/media/media4.jpg";
import Media_Img5 from "../assets/media/media5.jpg";
import Media_Img6 from "../assets/media/media6.jpg";
import Media_Img7 from "../assets/media/media7.jpg";
import Media_Img8 from "../assets/media/media8.jpg";
import Media_Img9 from "../assets/media/media9.jpg";
import Media_Img10 from "../assets/media/media10.jpg";

import Lines_IMG from "../assets/lines.png";
import User_IMG from "../assets/user.jpg";
import User1_IMG from "../assets/user1.png";
import Com1_IMG from "../assets/com1.png";
import Com2_IMG from "../assets/com2.png";
import Com3_IMG from "../assets/com3.png";
import Resource_IMG1 from "../assets/resources/img1.png";
import Resource_IMG2 from "../assets/resources/img2.jpg";
import Resource_IMG3 from "../assets/resources/img3.jpg";
import Resource_IMG4 from "../assets/resources/img4.jpg";
import Resource_IMG5 from "../assets/resources/img5.jpg";
import Resource_IMG6 from "../assets/resources/img6.jpg";
import Resource_IMG7 from "../assets/resources/img7.jpg";
import Resource_IMG8 from "../assets/resources/img8.jpg";
import Resource_IMG9 from "../assets/resources/img9.jpg";
import Resource_IMG10 from "../assets/resources/img10.jpg";
import Resource_IMG11 from "../assets/resources/img11.jpg";
import Resource_IMG12 from "../assets/resources/img12.jpg";
import Resource_IMG13 from "../assets/resources/img13.jpg";
import Resource_IMG14 from "../assets/resources/img14.jpg";
import Resource_IMG15 from "../assets/resources/img15.jpg";
import Resource_IMG16 from "../assets/resources/img16.jpg";
import Resource_IMG17 from "../assets/resources/img17.jpg";
import Resource_IMG18 from "../assets/resources/img18.jpg";
import Resource_IMG19 from "../assets/resources/img19.jpg";
import Resource_IMG20 from "../assets/resources/img20.jpg";
import Resource_IMG21 from "../assets/resources/img21.jpg";
import Resource_IMG22 from "../assets/resources/img22.jpg";
import Resource_IMG23 from "../assets/resources/img23.jpg";
import Resource_IMG24 from "../assets/resources/img24.jpg";
import Big_IMG from "../assets/bimg.jpg";
import Follow1_IMG from "../assets/follow1.png";
import Follow2_IMG from "../assets/follow2.png";
import Notifications_IMG from "../assets/notifications/noti1.svg";
import Notifications_IMG1 from "../assets/notifications/noti2.svg";
import Notifications_IMG2 from "../assets/notifications/noti3.svg";
import Notifications_IMG3 from "../assets/notifications/noti4.svg";
import Notifications_IMG4 from "../assets/notifications/noti5.svg";
import Notifications_IMG5 from "../assets/notifications/noti6.svg";

// Vendor Images
import Vendor_Home_IMG from "../assets/vendorimages/home.svg";
import Vendor_Icon1_IMG from "../assets/vendorimages/icons/icon1.svg";
import Vendor_Icon2_IMG from "../assets/vendorimages/icons/icon2.svg";
import Vendor_Icon3_IMG from "../assets/vendorimages/icons/icon3.svg";
import Vendor_Icon4_IMG from "../assets/vendorimages/icons/icon4.svg";
import Vendor_Icon5_IMG from "../assets/vendorimages/icons/icon5.svg";
import Vendor_User_IMG from "../assets/vendorimages/user.jpg";
import Vendor_Company_IMG from "../assets/vendorimages/company.png";
import Edit_IMG from "../assets/vendorimages/icons/editicon.svg";
import Delete_IMG from "../assets/vendorimages/icons/deleteicon.svg";
import Uploadimg_IMG from "../assets/vendorimages/uploadimg.png";
import Uploadimg1_IMG from "../assets/vendorimages/uploadimg1.png";
import AddPlus_IMG from "../assets/vendorimages/icons/addplus.svg";
import AddBigPlus_IMG from "../assets/vendorimages/icons/addbplus.svg";
import Minus_IMG from "../assets/vendorimages/icons/minus.svg";
import Badge1_IMG from "../assets/vendorimages/icons/badge/badge1.svg";
import Badge2_IMG from "../assets/vendorimages/icons/badge/badge2.svg";
import Badgecolor1_IMG from "../assets/vendorimages/icons/badge/badgecolor1.svg";
import Badgecolor2_IMG from "../assets/vendorimages/icons/badge/badgecolor2.svg";
import Badgecolor3_IMG from "../assets/vendorimages/icons/badge/badgecolor3.svg";
import emptyState from "../assets/svg/emptyState.svg";
import notFound from "../assets/svg/notFound.svg";
import Badge_IMG from "../assets/svg/badges.svg";
import Followers_IMG from "../assets/svg/follower.svg";
import Reviews_IMG from "../assets/svg/review.svg";
import Approved_IMG from "../assets/svg/approved.svg";
import Welcome_IMG from "../assets/svg/welcome.svg";
export const IMAGES = {
  Product_Img1,
  C_Logo1,
  C_Logo2,
  C_Logo3,
  C_Logo4,
  C_Logo5,
  C_Logo6,
  C_Logo7,
  C_Logo8,
  Badge1_IMG,
  Badge2_IMG,
  Badgecolor1_IMG,
  Badgecolor2_IMG,
  Badgecolor3_IMG,
  Minus_IMG,
  AddBigPlus_IMG,
  AddPlus_IMG,
  Uploadimg1_IMG,
  Uploadimg_IMG,
  Edit_IMG,
  Delete_IMG,
  Vendor_Company_IMG,
  Vendor_User_IMG,
  Vendor_Icon1_IMG,
  Vendor_Icon2_IMG,
  Vendor_Icon3_IMG,
  Vendor_Icon4_IMG,
  Vendor_Icon5_IMG,
  Vendor_Home_IMG,
  Follow1_IMG,
  Follow2_IMG,
  Notifications_IMG,
  Notifications_IMG1,
  Notifications_IMG2,
  Notifications_IMG3,
  Notifications_IMG4,
  Notifications_IMG5,
  Edit_Img,
  RArrow_Img,
  Thanks_Img,
  Earthquake_Img,
  VIcon1_Img,
  VIcon2_Img,
  VIcon3_Img,
  VIcon4_Img,
  CheckCircle_Img,
  RightArrow_Img,
  Checkuser_Img,
  Aboutsvg_Img,
  Gradient1_Img,
  Value1_Img,
  Value2_Img,
  Value3_Img,
  Help_Img,
  Big_IMG,
  Resource_IMG1,
  Resource_IMG2,
  Resource_IMG3,
  Resource_IMG4,
  Resource_IMG5,
  Resource_IMG6,
  Resource_IMG7,
  Resource_IMG8,
  Resource_IMG9,
  Resource_IMG10,
  Resource_IMG11,
  Resource_IMG12,
  Resource_IMG13,
  Resource_IMG14,
  Resource_IMG15,
  Resource_IMG16,
  Resource_IMG17,
  Resource_IMG18,
  Resource_IMG19,
  Resource_IMG20,
  Resource_IMG21,
  Resource_IMG22,
  Resource_IMG23,
  Resource_IMG24,
  Com1_IMG,
  Com2_IMG,
  Com3_IMG,
  User_IMG,
  Verified,
  User1_IMG,
  Search_Normal,
  Lines_IMG,
  Play_Circle,
  Media_Img1,
  Media_Img2,
  Media_Img3,
  Media_Img4,
  Media_Img5,
  Media_Img6,
  Media_Img7,
  Media_Img8,
  Media_Img9,
  Media_Img10,
  Circle_IMG1,
  Circle_IMG2,
  Circle_IMG3,
  LogoIcon_IMG1,
  LogoIcon_IMG2,
  LogoIcon_IMG3,
  LogoIcon_IMG4,
  LogoIcon_IMG5,
  LogoIcon_IMG6,
  LogoIcon_IMG7,
  LogoIcon_IMG8,
  LogoIcon_IMG9,
  LogoIcon_IMG10,
  LogoIcon_IMG11,
  LogoIcon_IMG12,
  LogoIcon_IMG13,
  LogoIcon_IMG14,
  Product_Img,
  Breadcrumb_Img,
  Reach_Img,
  Clientsvg1_Img,
  Clientsvg2_Img,
  User1_Img,
  User2_Img,
  User3_Img,
  BuyerTransparent_Img,
  Buyer_Img,
  Review_Img,
  Icon_Social1,
  Icon_Social2,
  Icon_Social3,
  Icon_Social4,
  Logo,
  Banner_Img,
  Gradient_Img,
  Logo1,
  Logo2,
  Logo3,
  Logo4,
  Logo5,
  Logo6,
  Logo7,
  Logo8,
  Logo9,
  short_logo,
  linkedin,
  twitter,
  emptyState,
  notFound,
  about_img,
  Badge_IMG,
  Followers_IMG,
  Reviews_IMG,
  Approved_IMG,
  Welcome_IMG
};

export default IMAGES;
